import React, { Component } from 'react'

import BkFlowPolicyViewerTabs from '../elements/BkFlowPolicyViewerTabs'
import BkFlowPolicyViewerContent from '../elements/BkFlowPolicyViewerContent'

class BkFlowPolicyViewer extends Component {

  constructor(props) {
    super(props)
    this.state = {
      currentPolicy: '0'
    }
  }

  handlePolicyClick(policyKey) {
    this.setState({
      currentPolicy: policyKey
    })
  }

  render() {
    const {
      configData,
      policyGroup,
      policies,
    } = this.props

    return (
      <div className="bk-flow__policy-viewer">
        <BkFlowPolicyViewerTabs
        	policies={policies}
        	currentPolicy={this.state.currentPolicy}
          policyEvent={(policyKey) => this.handlePolicyClick(policyKey)}
        />
        <BkFlowPolicyViewerContent
          configData={configData}
          policyGroup={policyGroup}
          policies={policies}
          currentPolicy={this.state.currentPolicy}
        />
      </div>
    )
  }
}

export default BkFlowPolicyViewer



// WEBPACK FOOTER //
// ./src/components/policies/layouts/BkFlowPolicyViewer.js